<template>
  <div class="score" v-show="this.detailsManyData.resultMap&&this.detailsManyData.resultMap.ahiAVG">
    <div class="myCharts">
      <div class="bt">
        <img src="../../../assets/icon_AHI.png" alt="" />
        <span style="position: relative; top: 4px" v-if="this.detailsManyData.resultMap&&this.detailsManyData.resultMap.ahiAVG">
			呼吸异常指数  平均{{ detailsManyData.resultMap.ahiAVG.toFixed(2) }}</span>
        <span class="ahi-line"></span>
        <span style="position: relative; top: 4px">异常参考</span>
      </div>
      <div
        id="myChartahis"
        style="height: 126px;margin-left: 20px;margin-bottom: 10px;"
        key="ahis"
      ></div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    score: 0,
    detailsManyData: {},
    dataTitleList: null,
  },
  data() {
    return {
      myChartahis: null,
      good: 0,
    };
  },
  methods: {
    getChartAhis() {
      if (this.myChartahis != null && this.myChartahis!= "" && this.myChartahis!= undefined) {
        this.myChartahis.dispose();
      }
        this.myChartahis = this.$echarts.init(
          document.getElementById("myChartahis")
        );
      var ahiX = [];
      for(var i = 0; i < this.detailsManyData.resultMap.ahiX.length; i++){
        ahiX[i] = this.detailsManyData.resultMap.ahiX[i].replace(",", "-");
      }
      var ahiY = [];
      for(var i = 0; i < this.detailsManyData.resultMap.ahiy.length; i++){
        if(this.detailsManyData.resultMap.scoreY[i] != 0){
          ahiY[i] = {
            value: this.detailsManyData.resultMap.ahiy[i] == 0 ? 0.05
                  : this.detailsManyData.resultMap.ahiy[i]
                  ? this.detailsManyData.resultMap.ahiy[i]
                  : -1
          }
        } else {
          ahiY[i] = {
            value: -1
          };
        }
      }
      
      var optionScore = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderColor: "rgba(24, 144, 255, 0.8)",
          // borderWidth: 1,
          borderRadius: 5,
          formatter: function (params) {
            console.log(params[0].data);
            // return params[0].data.value;
            if (params[0].data.value == -1) return params[0].name + "</br>" + "紊乱指数 - ";
            if(params[0].data.value == 0.05) return params[0].name + "</br>" + "紊乱指数 0 ";
            return params[0].name + "</br>" + "紊乱指数" + params[0].data.value;
          },
        },
        grid: {
          left: "0%",
          right: "0%",
          top: "10%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
            },
            //data: this.detailsManyData.resultMap.ahiX,
			      data: ahiX,
          },
        ],

        yAxis: [
          {
            type: "value",
            min: 0,
            max: Math.max(...this.detailsManyData.resultMap.ahiy) > 5 ? Math.max(...this.detailsManyData.resultMap.ahiy) : 5,
            logBase: 10,
            interval: 30,
            splitLine: {
              show: false,
            },
            axisLabel: {
              formatter: function (value) {
                if (value == 0) return value;
                else return value + "";
              },
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
              show: true,
            },
          },
        ],
        series: [
          {
            data: ahiY,
            type: "bar",
            barWidth: ahiY.length > 7 ? "20" : "30",
            itemStyle: {
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [4, 4, 0, 0],
              color: new this.$echarts.graphic.LinearGradient(0,1,0,0,[
                {
                  offset:0,
                  color:"rgba(77, 142, 247, 1)",
                },
                {
                  offset:1,
                  color:"rgba(195, 148, 254, 1)",
                }
              ]),
              },
            },
              markLine: {
              symbol: "none",
              emphasis: {
                lineStyle: {
                  width: 1, // hover时的折线宽度
                },
              },
              data: [
                {
                  silent: false, //鼠标悬停事件  true没有，false有
                  lineStyle: {
                    //警戒线的样式  ，虚实  颜色
                    type: "dashed",
                    color: "#C394FE",
                  },
                  label: {
                    position: "end",
                    formatter: function(fs){
                      console.log(123123);
                    },
                  },
                  yAxis: this.detailsManyData.resultMap.ahiAVG, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                },
                {
                  silent: false, //鼠标悬停事件  true没有，false有
                  lineStyle: {
                    //警戒线的样式  ，虚实  颜色
                    type: "dashed",
                    color: "#FF4D4F",
                  },
                  label: {
                    position: "end",
                    formatter: "",
                  },
                  yAxis: 5, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                },
              ],
            },
          },
        ],
      };

      this.myChartahis.clear();
      this.myChartahis.setOption(optionScore);
      window.addEventListener("resize", () => {
        this.myChartahis.resize();
      });

      //模拟得分仪表盘
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
.ahi-line {
  width: 20px;
  height: 20px;
  border-bottom: 1.4px dashed #ff4d4f;
  border-width: 2px;
  position: relative;
  top: -4px;
  margin: 0px 5px;
}
</style>
